import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import { store,persistor  } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.scss';
import { PersistGate } from 'redux-persist/integration/react';

import("./tracing")
.then(() => console.log("Tracing started"))
.catch((error) => console.error("Error starting tracing", error));
if(localStorage.getItem("showConsole")!=="Y") {
	// console.log = function() {};
}

const container = document.getElementById('root')!;
const root = createRoot(container);
sessionStorage.setItem('refreshToken','BearereyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZWNyZXRBY2Nlc3NDb2RlIjoiNzU4MmJiNjgtN2UyZi0xMWVlLWJjZDAtMDA1MDU2OWI4NjU5IiwiaWQiOjEsInRpbWVTdGFtcCI6MTcyMTUwMDQ5NTM5NiwibmJmIjoxNzIxNDE0MDk1LjM5NiwiZXhwIjoxNzI0MDkyNDk1LjM5NiwiaWF0IjoxNzIxNTAwNDk1LjM5NiwiaXNzIjoiMzc2OWU4N2EtN2Q3ZS00MDVjLWI1ZDctZTFiMzZlMzllN2Y1IiwiYXVkIjoiaHR0cDovL2xvY2FsaG9zdDo2NDA2NC8ifQ.vbanJpkqu2pHyJJ7KmwMKh9u5Jevzqb-RqwbUOApZbs');//setting this for signup/login/logout page not opening as per manoj yadav
root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<BrowserRouter basename="/learning">
				<App />
			</BrowserRouter>
   	 	</PersistGate>
	</Provider>
);
reportWebVitals();
